import { render, staticRenderFns } from "./EntityEvenements.vue?vue&type=template&id=2df4999e&"
import script from "./EntityEvenements.vue?vue&type=script&lang=js&"
export * from "./EntityEvenements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports